module.exports = __webpack_public_path__ + "static/media/Gravity-Book.9a3e0c5a.otf";